<template>
  <div
    id="primer"
    :class="{
      mask: true,
      primer: true,
      AR: $i18n.locale == 'AR',
    }"
    @touchmove.prevent
  >
    <div class="primer_main_content mask_content" :class="$i18n.locale">
      <div class="header">
        <div
          class="icon back"
          @click="paytypechange('local')"
          v-if="paytype == 'card' && cardarr.length > 0"
        ></div>
        <p>{{ paytype == 'card' ? $t('pay.newCard') : $t('pay.storedCard') }}</p>
        <div class="icon close" @click="cancel()"></div>
      </div>

      <div class="card-content" v-loading="!cardloadis || payis" :class="{ loading: !cardloadis }">
        <!-- 已保存卡 -->
        <div class="card-list" v-if="paytype == 'local' && cardloadis">
          <LocalCardList
            :vaultManager="vaultManager"
            :cardList="cardarr"
            @deletecard="deletecard"
            ref="localCardList"
          />
          <div class="switch-card medium">
            <div class="switch-txt">{{ $t('primer.newCard') }}</div>
            <div class="switch-btn btn-link" @click="paytypechange('new')">
              {{ $t('btn.addNewCard') }}
            </div>
          </div>
        </div>
        <!-- 新卡 -->
        <div class="new-card-list" v-show="paytype == 'card' && cardloadis">
          <div class="text regular">{{ $t('payment.card') }}</div>
          <div class="card_icon">
            <img src="@img/primer/visa.png" />
            <img src="@img/primer/mastercard.png" />
            <img src="@img/primer/amex.png" />
            <img src="@img/primer/discover.png" />
            <img src="@img/primer/jcb.png" />
          </div>

          <div id="card_main">
            <div class="card_main_content">
              <div class="card_field fullwidth">
                <div
                  id="card-number"
                  :class="{
                    red: nummerinput == 'red',
                    green: nummerinput == 'green',
                    blue: nummerinput == 'blue',
                  }"
                  class="card_filed_con fullwidth"
                >
                  <p class="card_input_label">{{ $t('primer.card') }}*</p>
                  <div class="card_input_content" id="card-number-input"></div>
                  <img v-if="cardstyle == 'VISA'" class="card_show" src="@img/primer/visa.png" />
                  <img
                    v-else-if="cardstyle == 'MASTERCARD'"
                    class="card_show"
                    src="@img/primer/mastercard.png"
                  />
                  <img v-else-if="cardstyle == 'JCB'" class="card_show" src="@img/primer/jcb.png" />
                  <img
                    v-else-if="cardstyle == 'DISCOVER'"
                    class="card_show"
                    src="@img/primer/discover.png"
                  />
                  <img
                    v-else-if="cardstyle == 'AMEX'"
                    class="card_show"
                    src="@img/primer/amex.png"
                  />
                  <img v-else class="card_show" src="@img/primer/cardlogo.png" />
                </div>
                <p class="errortext" v-show="nummbererrortext != '' && nummerinput == 'red'">
                  {{ nummbererrortext }}
                </p>
              </div>

              <div class="card_field halfwidth">
                <div
                  id="card-expiry"
                  :class="{
                    red: expiryinputstyle == 'red',
                    green: expiryinputstyle == 'green',
                    blue: expiryinputstyle == 'blue',
                  }"
                  class="card_filed_con"
                >
                  <p class="card_input_label">{{ $t('primer.date') }}*</p>
                  <div class="card_input_content" id="card-expiry-input"></div>
                  <img
                    class="card_show"
                    v-if="expiryinputstyle != 'green'"
                    src="@img/primer/date.png"
                  />
                  <img class="card_show cardok" v-else src="@img/icon_primer_ok.png" />
                </div>
                <p
                  class="errortext"
                  v-show="expiryinputerrortext != '' && expiryinputstyle == 'red'"
                >
                  {{ expiryinputerrortext }}
                </p>
              </div>

              <div class="card_field halfwidth">
                <div
                  id="card-cvv"
                  :class="{
                    red: cvvinputstyle == 'red',
                    green: cvvinputstyle == 'green',
                    blue: cvvinputstyle == 'blue',
                  }"
                  class="card_filed_con"
                >
                  <p class="card_input_label">{{ $t('primer.cvv') }}*</p>
                  <div class="card_input_content" id="card-cvv-input"></div>
                  <img
                    class="card_show"
                    v-if="cvvinputstyle != 'green'"
                    src="@img/primer/cardcvv.png"
                  />
                  <img class="card_show cardok" v-else src="@img/icon_primer_ok.png" />
                </div>
                <p class="errortext" v-show="cvvinputerrortext != '' && cvvinputstyle == 'red'">
                  {{ cvvinputerrortext }}
                </p>
              </div>

              <!-- <div class="card_field fullwidth">
                <div
                  id="card-holder"
                  :class="{
                    red: holderinput == 'red',
                    green: holderinput == 'green',
                    blue: holderinput == 'blue',
                  }"
                  class="card_filed_con"
                >
                  <p class="card_input_label">{{ $t('primer.cardName') }}*</p>
                  <input
                    class="card_input_content regular"
                    id="card-holder-input"
                    :placeholder="$t('primer.name')"
                  />
                  <img
                    class="card_show cardok"
                    v-if="holderinput == 'green'"
                    src="@img/icon_primer_ok.png"
                  />
                </div>
                <p class="errortext" v-show="holdererrortext != '' && holderinput == 'red'">
                  {{ holdererrortext }}
                </p>
              </div> -->

              <CardFieldWrap
                :label="`${$t('primer.cardName')}*`"
                :errorText="holdererrortext"
                :statusClass="holderinput"
                @click.stop.native="$refs.holderInputRef && $refs.holderInputRef.focus()"
              >
                <input
                  slot="input"
                  ref="holderInputRef"
                  class="card_input_content"
                  id="card-holder-input"
                  :placeholder="$t('primer.name')"
                />
              </CardFieldWrap>

              <FieldPostCode
                ref="postcodeInput"
                :defaultPostcode="postcode"
                v-if="isShowPostCode && paytype == 'card'"
              />
            </div>

            <!-- 保存卡信息 -->
            <div class="card_save regular">
              <div
                class="icon"
                :class="{ active: cardsaveis }"
                @click="cardsaveis = !cardsaveis"
              ></div>
              <span @click="cardsavechange()">{{ $t('primer.save') }}</span>
              <img
                v-if="loginType === 'role_id'"
                id="cardsavequestion"
                @click.stop="cardsavequestionchange"
                src="@img/primer/question.png"
              />
              <p v-show="cardsaveInfois" class="cardsaveInfo common_popover regular">
                {{ $t('primer.saveInfo') }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer">
        <div class="button card-submit" @click="localsubmit" v-if="paytype == 'local'">
          <img class="btn-img" src="@img/primer/konck.png" />
          <span>
            {{ $t('primer.pay') }} {{ payinfo.currency_label
            }}{{ (payinfo.tax ? payinfo.taxed_price : payinfo.amount) | formatPrice }}
          </span>
        </div>
        <div class="button card-submit" id="card-submit" v-if="paytype == 'card'">
          <img class="btn-img" src="@img/primer/konck.png" />
          <span>
            {{ $t('primer.pay') }} {{ payinfo.currency_label
            }}{{ (payinfo.tax ? payinfo.taxed_price : payinfo.amount) | formatPrice }}
          </span>
        </div>
        <div class="card_safe regular">
          <div class="safe_icon" />
          <span> {{ $t('primer.safe') }}</span>
          <div class="safe_icon_2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { getorder, primerUpdate, primer_payment_fail } from '@/api/index.js'
import LocalCardList from './localCardList'
import { PRIMER_FAIL_KEY, PRIMER_ORDER_STATUS } from '@/enum'
import { mapState, mapGetters } from 'vuex'
import { getCallPaymentLimitTrackingProps } from '@/tool/packagePurchaseLimit'
import mixinCheckTaxExpires from '@/mixins/mixinCheckTaxExpires.js'
import FieldPostCode from './localCardList/customFields/FieldPostCode.vue'
import CardFieldWrap from './localCardList/customFields/CardFieldWrap.vue'
export default {
  name: 'primer',
  mixins: [mixinCheckTaxExpires],
  props: ['payinfo', 'airwallex_deviceid'],
  provide() {
    return {
      getOrderId: () => {
        return this.orderid
      },
    }
  },
  inject: ['newCheckPay'],
  components: {
    LocalCardList,
    FieldPostCode,
    CardFieldWrap,
  },
  computed: {
    ...mapGetters(['isShowPostCode']),
    ...mapState({
      gameId: (state) => state.app.gameId,
      loginType: (state) => state.user.loginType,
      userInfo: (state) => state.user.userInfo,
      isProductionTax: (state) => state.app.isProductionTax,
      userIpCountry: (state) => state.user.userIpCountry,
      postcode: (state) => state.user.postcode,
    }),
  },
  data() {
    return {
      cardstyle: '',
      payis: false,
      cardsaveis: false,
      paytype: 'card',
      cardarr: [],
      carddict: {},
      headless: '',
      vaultManager: '',
      deletecardinfo: '',
      nummerinput: '',
      nummbererrortext: '',
      cvvinputstyle: '',
      cvvinputerrortext: '',
      expiryinputstyle: '',
      expiryinputerrortext: '',
      holderinput: '',
      holdererrortext: '',
      maillErrortext: '',
      maillInput: '',
      postCodeErrortext: '',
      postcodeInput: '',
      cardloadis: true,
      cardsaveInfois: false,
      selcvvInput: '',
      local_input: '',
      local_input_errortext: '',
      //预订单ID
      orderid: '',
      showMailPopover: false,
      clientSession: null,

      rootFont: 0,
    }
  },
  directives: {
    ClickOutside,
  },
  created() {
    this.cardloadis = false
    this.rootFont = parseFloat(document.documentElement.style.fontSize)
  },
  mounted() {
    this.cardpay()
    var vm = this

    var primer = document.getElementById('primer')
    primer.onclick = function () {
      vm.cardsaveInfois = false
    }
  },
  methods: {
    hideMailPopover() {
      this.showMailPopover = false
    },
    cardsavequestionchange() {
      this.cardsaveInfois = !this.cardsaveInfois
    },
    priceinit(priceString) {
      const price = parseFloat(priceString)
      if (this.$i18n.locale === 'AR') {
        return price.toLocaleString('EN', { useGrouping: true }).replace(/\s/g, ' ')
      }
      return price.toLocaleString(this.$i18n.locale, { useGrouping: true }).replace(/\s/g, ' ')
    },
    deletecard(item) {
      this.deletecardinfo = item
      this.$confirm({
        title: this.$t('primer.removeCard'),
        content: this.$t('primer.removeInfo'),
        icon: 'warning',
        confirm: this.confirmdelete,
      })
    },
    confirmdelete() {
      this.cardarr = this.cardarr.filter((card) => card.id !== this.deletecardinfo.id)

      if (this.cardarr.length == 0) {
        this.paytype = 'card'
      }

      var cardarr = this.carddict[this.deletecardinfo.analyticsId]
      cardarr.forEach((res) => {
        this.vaultManager.deleteVaultedPaymentMethod(res)
      })
    },
    paytypechange(sty) {
      if (sty == 'new') {
        this.paytype = 'card'
      } else {
        this.paytype = 'local'
      }
    },
    cardsavechange() {
      this.cardsaveis = !this.cardsaveis
    },
    cancel() {
      this.$parent.cancelpay()
      this.$parent.payment_log.report('web_payment_userpay_cancel')
    },

    // 已存卡支付
    async localsubmit() {
      if (this.payis) return
      const ans = await this.$refs.localCardList.validate()
      console.log('ans', ans)
      const { value, valid } = ans

      if (!valid) return
      try {
        this.payis = true

        const taData = {
          iap_product_id: this.payinfo.product_id,
          payment_type: 'card',
          operator_type: 3,
          amount:
            this.isProductionTax && this.payinfo.taxed_price
              ? this.payinfo.taxed_price
              : this.payinfo.amount,
          currency: this.payinfo.currency,
          server_id: this.payinfo.user_extra_value,
          tid: this.orderid,
          use_type: '2',
          ...getCallPaymentLimitTrackingProps(this.$parent.pack),
          ...(this.$store.state.app.fromInstalledWebApp ? { open_ui_old: 'desktop_shortcut' } : {}),
        }
        if (this.gameId === '20195') {
          taData.iap_name = this.payinfo.data_name || ''
          taData.pkg_id = this.payinfo.pack_id || ''
          taData.reward = this.payinfo.reward || ''
        }
        this.$ta.track('call_payment', taData)

        if (this.clientSession && this.clientSession.clientToken) {
          const params = {
            provider_order_id: this.orderid,
            game_id: this.payinfo.game_id,
            whether_save_card: 0,
            client_session: this.clientSession.clientToken,
            // email_address: value.email,
            pay_type: 2,
            post_code: this.payinfo.post_code,
          }
          // 需要等primerUpdate返回结果后再进行提交操作
          await primerUpdate(params)
        }
        this.vaultManager.startPaymentFlow(value.selectID, {
          cvv: value.cvv,
        })
      } catch (error) {
        this.payis = false
        console.error(error)
      }
    },
    async cardpay() {
      var vm = this
      console.log('payinfo----')
      //console.log(this.payinfo);
      const params = {
        ...this.payinfo,
        user_id: this.userInfo.user_id,
        airwallex_deviceid: this.airwallex_deviceid,
        enter_type: this.loginType,
        bonus: this.$store.state.user.isFirst ? 1 : 0,
        taxed: this.isProductionTax,
      }
      const uid = this.$utils.customLocalStorage.getItem(
        `web_shopper_uid_${this.userInfo.user_uid}`
      )
      if (uid) {
        params.web_shopper_uid = uid
      }

      const res = await getorder(params)

      //校验黑名单之类的
      if (!this.newCheckPay(res)) {
        return false
      }

      if (res.data.code == 1) {
        var clientSession = res.data.data.primer_data
        this.clientSession = clientSession
        this.orderid = res.data.data.provider_order_id

        const taData = {
          iap_product_id: this.payinfo.product_id,
          payment_type: 'card',
          operator_type: 2,
          amount:
            this.isProductionTax && this.payinfo.taxed_price
              ? this.payinfo.taxed_price
              : this.payinfo.amount,
          currency: this.payinfo.currency,
          server_id: this.payinfo.user_extra_value,
          tid: this.orderid,
          ...getCallPaymentLimitTrackingProps(this.$parent.pack),
          ...(this.$store.state.app.fromInstalledWebApp ? { open_ui_old: 'desktop_shortcut' } : {}),
        }
        if (this.gameId === '20195') {
          taData.iap_name = this.payinfo.data_name || ''
          taData.pkg_id = this.payinfo.pack_id || ''
          taData.reward = this.payinfo.reward || ''
        }
        this.$ta.track('call_payment', taData)

        // 缓存adyen uid
        if (res.data.data.web_shopper_uid) {
          this.$utils.customLocalStorage.setItem(
            `web_shopper_uid_${this.userInfo.user_uid}`,
            res.data.data.web_shopper_uid
          )
        }

        this.$utils.customSessionStorage.setItem(
          'provider_order_id',
          res.data.data.provider_order_id
        )
        vm.$parent.updateProviderOrderId(res.data.data.provider_order_id)
        vm.$parent.payment_log.set_properties({
          cg_request_id: res.data.data.provider_order_id + '',
        })
      } else {
        this.$parent.failpay('Order failed！')
        this.$parent.payment_log.report('web_payment_getorder_fail', {
          code: 3,
          msg: res.data.msg ? res.data.msg : 'Order failed',
        })
        this.$rum.report(
          'pay_err',
          {
            paystyle: 'primer',
            type: 'getorder',
            response: res.data,
            prams: this.payinfo,
          },
          3
        )
        return
      }

      //console.log(clientSession);

      const { clientToken } = clientSession
      const { Primer } = window
      //console.log(clientToken)
      // Create an instance of the headless checkout

      this.headless = await Primer.createHeadless(clientToken, {
        card: {
          cardholderName: {
            required: false,
          },
        },
        onAvailablePaymentMethodsLoad(paymentMethods) {
          // Called when the available payment methods are retrieved
          console.log('paymentMethods------')
          console.log(paymentMethods)

          for (const paymentMethod of paymentMethods) {
            // `type` is a unique ID representing the payment method
            const { type, managerType } = paymentMethod
          }
        },
        onCheckoutComplete({ payment }) {
          // Notifies you that a payment was created
          // Move on to next step in your checkout flow:
          // e.g. Show a success message, giving access to the service, fulfilling the order, ...
          console.log('onCheckoutComplete', payment)

          vm.$rum.report(
            'primer_checkout_complete',
            {
              paystyle: 'primer',
              type: 'sdkcallback',
              response: payment,
              prams: params,
            },
            1
          )

          setTimeout(() => {
            // 支付失败了查询失败原因
            let isShipBlocked = false
            primer_payment_fail({
              uuid: payment.id,
              provider_order_id: vm.orderid,
            })
              .then((res) => {
                if (
                  res.data.code === 1 &&
                  res.data.data.order_status === PRIMER_ORDER_STATUS.SHIP_BLOCKED
                ) {
                  isShipBlocked = true
                }
              })
              .finally(() => {
                vm.payis = false
                if (isShipBlocked) {
                  // primer 验单是发货拦截走特殊失败逻辑
                  vm.$parent.failpay({
                    data: {
                      uuid: vm.orderid,
                      now_timestamp: vm.$utils.formatUTCTimestamp(Date.now()),
                      fail_code: 'pay.limitPackBuyFail',
                      tax: vm.payinfo.tax,
                      taxed_price: vm.payinfo.taxed_price,
                    },
                  })
                  vm.$rum.report(
                    'primer_ship_blocked',
                    {
                      paystyle: 'primer',
                      type: 'checkout_complete_order_check',
                      response: payment,
                      prams: params,
                    },
                    1
                  )
                } else {
                  vm.$parent.payment_log.report('web_payment_primer_success')
                  vm.$parent.successpay({
                    uuid: payment.id,
                    now_timestamp: vm.$utils.formatUTCTimestamp(Date.now()),
                  })
                  vm.$rum.report(
                    'pay_sucess',
                    {
                      paystyle: 'primer',
                      type: 'sdkcallback',
                      response: payment,
                      prams: params,
                    },
                    1
                  )
                }
              })
          }, 300)
        },
        onCheckoutFail(error, { payment }, handler) {
          payment = payment || {}
          vm.$rum.report('primer_fail', { error: error, paymentId: payment.id })
          console.log(error)
          console.log('onCheckouthandler', handler)

          setTimeout(() => {
            // 支付失败了查询失败原因
            primer_payment_fail({
              uuid: payment.id,
              provider_order_id: vm.orderid,
            })
              .then((res) => {
                let langKey = ''
                let uuid = payment.id
                const data = res.data.data
                if (res.data.code == 1) {
                  if (data.order_status === PRIMER_ORDER_STATUS.SHIP_BLOCKED) {
                    langKey = 'pay.limitPackBuyFail'
                    uuid = vm.orderid
                    vm.$rum.report(
                      'primer_ship_blocked',
                      {
                        paystyle: 'primer',
                        type: 'checkout_complete_order_check',
                        response: payment,
                        prams: params,
                      },
                      1
                    )
                  } else {
                    langKey = PRIMER_FAIL_KEY[data.failed_code] || PRIMER_FAIL_KEY.default
                  }
                }
                vm.$parent.failpay({
                  data: {
                    uuid: uuid,
                    now_timestamp: vm.$utils.formatUTCTimestamp(Date.now()),
                    fail_code: langKey,
                    real_amount: data.real_amount,
                    tax: data.tax,
                    taxed_price: data.taxed_price,
                  },
                })
              })
              .catch(() => {
                vm.$parent.failpay({
                  data: {
                    uuid: payment.id,
                    now_timestamp: vm.$utils.formatUTCTimestamp(Date.now()),
                  },
                })
              })
              .finally(() => {
                vm.payis = false

                vm.$parent.payment_log.report('web_payment_primer_fail', {
                  code: 3,
                  msg: 'fail',
                })

                vm.$rum.report(
                  'pay_err',
                  {
                    paystyle: 'primer',
                    type: 'fail',
                    response: payment,
                    prams: params,
                  },
                  3
                )
              })
          }, 300)

          // Notifies you that the checkout flow has failed and a payment could not be created
          // This callback can also be used to display an error state within your own UI.
          // ⚠️ `handler` is undefined if the SDK does not expect anything from you
          if (!handler) {
            return
          }
          // ⚠️ If `handler` exists, you MUST call one of the functions of the handler
          // Show a default error message
          return handler.showErrorMessage()
        },
        redirect: {
          returntUrl: location.origin + location.pathname,
        },
        locale: 'legacy',
      })
      // Start the headless checkout
      await vm.headless.start()

      function card() {
        const submitButton = document.getElementById('card-submit')

        configureCardForm()
        async function configureCardForm() {
          const baseStyles = {
            height: 'auto',
            input: {
              base: {
                lineHeight: `${(0.48 * vm.rootFont).toFixed(4)}px`,
                height: `${(0.48 * vm.rootFont).toFixed(4)}px`,
                color: '#000000',
                fontSize: `${(0.4 * vm.rootFont).toFixed(4)}px`,
                textAlign: vm.$i18n.locale === 'AR' ? 'right' : 'left',
                fontWeight: 500,
                fontFamily:
                  '"roboto-medium", -apple-system, BlinkMacSystemFont, "Segoe UI", Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                placeholder: {
                  color: '#9D9D9D',
                  fontWeight: 400,
                  fontFamily:
                    '"roboto-regular", -apple-system, BlinkMacSystemFont, "Segoe UI", Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                },
              },
            },
          }
          // if (vm.$i18n.locale == 'AR') {
          //   baseStyles.input.base.direction = 'rtl'
          // }
          // Create the payment method manager
          const cardManager = await vm.headless.createPaymentMethodManager('PAYMENT_CARD', {
            onCardNetworksChange(data) {
              // ...
              if (
                data.detectedCardNetworks &&
                data.detectedCardNetworks.preferred &&
                data.detectedCardNetworks.preferred.network
              ) {
                // console.log('card type ------------')
                // console.log(data.detectedCardNetworks.preferred.network)
                vm.cardstyle = data.detectedCardNetworks.preferred.network
              } else {
                vm.cardstyle = ''
              }
            },
          })

          // Create the hosted inputs
          const { cardNumberInput, expiryInput, cvvInput } = cardManager.createHostedInputs()

          await Promise.all([
            cardNumberInput.render('card-number-input', {
              placeholder: vm.$t('primer.bankCard'),
              ariaLabel: 'Card number',
              style: baseStyles,
            }),
            expiryInput.render('card-expiry-input', {
              placeholder: 'MM/YY',
              ariaLabel: 'Expiry date',
              style: baseStyles,
            }),
            cvvInput.render('card-cvv-input', {
              placeholder: vm.$t('primer.number'),
              ariaLabel: 'CVV',
              style: baseStyles,
            }),
          ])

          var errortext = vm.$t('primer.error')
          var emptytext = vm.$t('primer.empty')

          // const costomFileds = vm.addCostomFiledValidation()

          // Set the cardholder name if it changes
          var holderid = document.getElementById('card-holder-input')
          console.log('holderid=====', holderid)

          //姓名目前不校验
          // holderid.addEventListener('focus', e => {
          //   if (vm.holderinput != 'green') {
          //     vm.holderinput = 'blue'
          //   }
          // })
          // var card_holder = document.getElementById('card-holder')
          // card_holder.onclick = function () {
          //   holderid.focus()
          // }
          holderid.addEventListener('input', (e) => {
            cardManager.setCardholderName(e.target.value)
            if (!e.target.value) {
              vm.holderinput = 'blue'
              vm.holdererrortext = ''
            } else {
              vm.holderinput = 'green'
              vm.holdererrortext = ''
            }
          })
          holderid.addEventListener('blur', (e) => {
            if (!e.target.value) {
              vm.holderinput = 'red'
              vm.holdererrortext = emptytext
            } else {
              vm.holderinput = 'green'
              vm.holdererrortext = ''
            }
          })

          // Configure event listeners for supported events
          var card_number = document.getElementById('card-number')
          card_number.onclick = function () {
            cardNumberInput.focus()
          }
          cardNumberInput.addEventListener('change', (data) => {
            //console.log('cardNumberInput changed', data);

            if (data.valid == true) {
              vm.nummerinput = 'green'
              vm.nummbererrortext = ''
            } else {
              if (vm.nummberfocus) {
                vm.nummerinput = 'blue'
              }
              if (data.errorCode == 'cardRequired') {
                vm.nummbererrortext = emptytext
              } else {
                vm.nummbererrortext = errortext
              }
            }
          })
          cardNumberInput.addEventListener('blur', (data) => {
            vm.nummberfocus = false
            if (vm.nummerinput != 'green') {
              vm.nummerinput = 'red'
            } else {
              vm.nummbererrortext = ''
            }
          })
          cardNumberInput.addEventListener('focus', (data) => {
            vm.nummberfocus = true
          })

          var card_cvc = document.getElementById('card-cvv')
          card_cvc.onclick = function () {
            cvvInput.focus()
          }
          cvvInput.addEventListener('change', (data) => {
            // console.log('cvvInput changed', data);
            // console.log('cvvInput changed', vm.cardloadis);
            if (data.valid == true) {
              vm.cvvinputstyle = 'green'
              vm.cvvinputerrortext = ''
            } else {
              if (vm.cvvfocus) {
                vm.cvvinputstyle = 'blue'
              }
              if (data.errorCode == 'cvvRequired') {
                vm.cvvinputerrortext = emptytext
              } else {
                vm.cvvinputerrortext = errortext
              }
            }
          })
          cvvInput.addEventListener('blur', (data) => {
            vm.cvvfocus = false
            if (vm.cvvinputstyle != 'green') {
              vm.cvvinputstyle = 'red'
            } else {
              vm.cvvinputerrortext = ''
            }
          })
          cvvInput.addEventListener('focus', (data) => {
            vm.cvvfocus = true
          })

          const expiryhandleChange = (data) => {
            //console.log('expiryInput changed', data);
            if (data.valid == true) {
              vm.expiryinputstyle = 'green'
              vm.expiryinputerrortext = ''
              // if (vm.cvvinputstyle == '') {
              //   cvvInput.focus()
              // }
            } else {
              if (vm.expiryfocus) {
                vm.expiryinputstyle = 'blue'
              }
              if (data.errorCode == 'expiryRequired') {
                vm.expiryinputerrortext = emptytext
              } else {
                vm.expiryinputerrortext = errortext
              }
            }
          }
          const expiryhandleblur = (data) => {
            vm.expiryfocus = false
            if (vm.expiryinputstyle != 'green') {
              vm.expiryinputstyle = 'red'
            } else {
              vm.expiryinputerrortext = ''
            }
          }

          var card_expiry = document.getElementById('card-expiry')
          card_expiry.onclick = function () {
            expiryInput.focus()
          }
          expiryInput.addEventListener('change', expiryhandleChange)
          expiryInput.addEventListener('blur', expiryhandleblur)
          expiryInput.addEventListener('focus', (data) => {
            vm.expiryfocus = true
          })

          submitButton.addEventListener('click', async () => {
            if (vm.payis) return
            console.log('holderid.value', holderid.value)
            if (!holderid.value) {
              vm.holderinput = 'red'
              vm.holdererrortext = emptytext
              return
            } else {
              vm.holderinput = 'green'
              vm.holdererrortext = ''
            }

            let postcodeValidate = true
            if (vm.isShowPostCode) {
              postcodeValidate = await vm.$refs.postcodeInput.validatePostcode()
            }

            // primer原生验证
            const validate = await cardManager.validate()

            // 自定义表单验证
            // const costomValidate = costomFileds.validate()

            if (validate.valid && postcodeValidate) {
              // Submit the card input data to Primer for tokenization
              vm.payis = true

              const taData = {
                iap_product_id: vm.payinfo.product_id,
                payment_type: 'card',
                operator_type: 3,
                amount:
                  vm.isProductionTax && vm.payinfo.taxed_price
                    ? vm.payinfo.taxed_price
                    : vm.payinfo.amount,
                currency: vm.payinfo.currency,
                server_id: vm.payinfo.user_extra_value,
                tid: vm.orderid,
                use_type: '1',
                ...getCallPaymentLimitTrackingProps(vm.$parent.pack),
                ...(vm.$store.state.app.fromInstalledWebApp
                  ? { open_ui_old: 'desktop_shortcut' }
                  : {}),
              }
              if (vm.gameId === '20195') {
                taData.iap_name = vm.payinfo.data_name || ''
                taData.pkg_id = vm.payinfo.pack_id || ''
                taData.reward = vm.payinfo.reward || ''
              }
              vm.$ta.track('call_payment', taData)

              const params = {
                provider_order_id: vm.orderid,
                game_id: vm.payinfo.game_id,
                whether_save_card: vm.cardsaveis == true ? 1 : 0,
                client_session: clientToken,
                // email_address: costomValidate.value.email,
                pay_type: 1,
                post_code: vm.payinfo.post_code,
              }
              // 需要等primerUpdate返回结果后再提交，主要是更新是否保存卡信息
              await primerUpdate(params)
              await cardManager.submit()
            } else {
              if (vm.nummerinput != 'green') {
                vm.nummerinput = 'red'
              }
              if (vm.cvvinputstyle != 'green') {
                vm.cvvinputstyle = 'red'
              }
              if (vm.expiryinputstyle != 'green') {
                vm.expiryinputstyle = 'red'
              }
              var holderis = false
              for (let error of validate.validationErrors) {
                // 检查 name 是否为 "cardholderName"
                if (error.name === 'cardholderName') {
                  holderis = true // 如果找到，返回 true
                }
              }
              if (holderis) {
                vm.holderinput = 'red'
                vm.holdererrortext = errortext
              }
            }
          })

          vm.vaultManager = vm.headless.createVaultManager()

          console.log('拉取卡信息开始', vm.vaultManager)
          var cardarr = await vm.vaultManager.fetchVaultedPaymentMethods()
          console.log('拉取卡信息结束 ', cardarr)

          cardarr = cardarr.reverse()
          var realarr = []
          cardarr.forEach((res, index) => {
            if (vm.carddict[res.analyticsId]) {
              vm.carddict[res.analyticsId].push(res.id)
            } else {
              vm.carddict[res.analyticsId] = []
              vm.carddict[res.analyticsId].push(res.id)
              realarr.push(res)
            }
          })
          //给卡号排序,倒序排序
          vm.cardarr = realarr
          if (vm.cardarr.length > 0) {
            vm.paytype = 'local'
          }
          // 加载完成，关闭loading
          vm.cardloadis = true
        }
      }
      card()
    },
    addCostomFiledValidation() {
      // 邮箱校验
      var mailInput = document.getElementById('card-mail-input')
      var card_mail = document.getElementById('card-mail')
      card_mail.onclick = function () {
        mailInput.focus()
      }
      const validateEmail = (val) => {
        if (!val) {
          this.maillErrortext = this.$t('primer.empty')
          this.maillInput = 'red'
          return false
        }
        if (
          !/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}|(?:\[(?:(?:25[0-5]|2[0-4][0-9]|1?[0-9]{1,2})\.){3}(?:25[0-5]|2[0-4][0-9]|1?[0-9]{1,2})\]))$/.test(
            val
          )
        ) {
          this.maillErrortext = this.$t('primer.error')
          this.maillInput = 'red'
          return false
        }

        this.maillErrortext = ''
        this.maillInput = 'green'
        return true
      }

      mailInput.addEventListener('change', (e) => {
        validateEmail(e.target.value)
      })
      mailInput.addEventListener('input', (e) => {
        const ans = validateEmail(e.target.value)
        if (ans) {
          this.maillInput = 'green'
        } else {
          this.maillInput = 'blue'
        }
      })
      mailInput.addEventListener('blur', (e) => {
        validateEmail(e.target.value)
      })

      return {
        validate() {
          const arr = []
          arr.push(validateEmail(mailInput.value))
          return {
            valid: arr.every(Boolean),
            value: {
              email: mailInput.value,
            },
          }
        },
      }
    },
  },
}
</script>

<style lang="less">
@import './cardField.less';
</style>
<style lang="less" scoped>
.primer_main_content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* text-align: center; */
  background-color: #fff;
  max-width: 500px;
  max-height: 550px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;

  .header {
    height: 48px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 40px;
    position: relative;
    font-size: 18px;
    font-weight: 700;
    border-bottom: 1px solid rgba(230, 230, 230, 1);

    .icon {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 12px;
      cursor: pointer;
      &.back {
        left: 12px;
        .bg-image('icon_back');
      }
      &.close {
        right: 12px;
        .bg-image('icon_close');
      }
    }
  }

  .card-content {
    flex: 1;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    &.loading {
      min-height: 300px;
    }
    .switch-card {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      padding: 0 16px;
    }
    .switch-txt {
      font-size: 15px;
      font-weight: 500;
      color: #000000;
    }
    .switch-btn {
      text-decoration: underline;
    }
  }
  .card-list {
    flex: 1;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
  }
  .new-card-list {
    padding: 0 16px;
    padding-top: 8px;
    overflow: auto;
    .text {
      font-size: 10px;
      color: #62676b;
    }
    .card_icon {
      display: flex;
      gap: 4px;
      padding: 8px 0;

      img {
        height: 21px;
        width: auto;
      }
    }
  }

  .card_save {
    display: flex;
    height: 39px;

    font-weight: 400;
    align-items: center;
    font-size: 13px;
    color: #4d5358;
    cursor: pointer;
    position: relative;

    .icon {
      width: 16px;
      height: 16px;
      .bg-image('icon_checkbox');
      &.active {
        .bg-image('icon_checkbox_active');
      }
    }

    img:nth-child(3) {
      width: 12px;
      height: 12px;
    }

    span {
      margin-left: 8px;
      margin-right: 4px;
    }

    .cardsaveInfo {
      left: 122px;
      transform: translateY(-101%);
    }
  }

  .card-footer {
    padding: 12px 16px;
    border-top: 1px solid rgba(230, 230, 230, 1);
    flex-shrink: 0;

    .btn-img {
      height: 15px;
      margin-right: 8px;
    }

    .card_safe {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      font-size: 12px;
      color: rgba(193, 199, 205, 1);
      margin-top: 12px;
      .safe_icon {
        width: 20px;
        height: 20px;
        .bg-image('icon_safe');
      }
      .safe_icon_2 {
        width: 54px;
        height: 20px;
        .bg-image('icon_safe_2');
      }
    }
  }
}
.primer {
  .pchide {
    display: none;
  }

  .mobilehide {
    display: block;
  }

  .close {
    position: absolute;
    top: 27px;
    right: 30px;
    width: 15px;
    height: 15px;
    cursor: pointer;
    z-index: 1;
  }

  .cardload {
    height: 260px;
    display: flex;
    align-items: center;

    img {
      display: block;
      margin: 0 auto;
    }
  }

  .loadimg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 15px;
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.3);
  }

  #card_main {
    width: 100%;
    .card_main_content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: -8px;
    }
  }
}

.noticemask {
  display: flex;
  justify-content: center;
  user-select: none;
  align-items: center;
}

.ok_btn {
  justify-content: center;
}

.noticeapplogin {
  width: 420px;
  border-radius: 16px;
  padding-top: 24px;
  background: #fff;
  img {
    width: 100px;
    display: block;
    margin: 0 auto;
  }
}

@media (max-width: 1024px) {
  .primer_main_content {
    max-width: unset;
    width: 100%;
    transform: none;
    border-radius: 16px 16px 0px 0px;
    max-height: calc(100% - 50px);
    overflow: hidden;
    left: 0;
    top: unset;
    bottom: 0;
  }
  .primer {
    .pchide {
      display: block;
    }

    .mobilehide {
      display: none;
    }

    .errortext {
      font-size: 12px;
    }

    .loadimg {
      border-radius: 1.25rem 1.25rem 0px 0px;
    }

    .card_save {
      .cardsaveInfo {
        left: 20px;
      }
    }
  }

  .noticeapplogin {
    width: 84%;
  }

  .applogin {
    padding-bottom: 0;
  }
}
</style>
